<template>
    <v-card>
        <v-card-title>
        <span class="headline">Ajouter Port</span>
        </v-card-title>
        <v-card-text>
        <v-container>
            <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="portTmp.code" label="Code Port*" hint="exemple: TNRDS" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="portTmp.titre"  label="Nom Port" hint="exemple : Port de RADES"></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="portTmp.pays"  label="Pays" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field v-model="portTmp.adresse"  label="Adresse" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field v-model="portTmp.ville"  label="Ville" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field v-model="portTmp.code_postal"  label="Code Postal" required></v-text-field>
            </v-col>
            <!--<v-col cols="12" sm="4">
                <v-text-field v-model="portTmp.comission_import"  label="Comission Import" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field v-model="portTmp.type_facture"  label="Type Facture" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field v-model="portTmp.code_clause"  label="Code Clause" required></v-text-field>
            </v-col>-->
            </v-row>
        </v-container>
        <small>*toutes les cases indiquées avec étoiles sont obligatoires</small>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">Fermer</v-btn>
        <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addPort">Ajouter</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: 'add-port',
    data: () => ({
        snackbar: false,
        snackbarText: '',
        color: "success",
        portTmp: {},
        port: []
    }),
    methods: {
        closeDialog(){
            this.$emit('close', true)
        },
        addPort(){
        this.axios.post('/port/create', this.portTmp, {
          }).then((res) => {
            if(res.data === 'error'){
              this.color = "error"
              this.snackbarText = "Essayez de remplir tous les champs obligatoires."
              this.snackbar = true
            }else{
              this.color = "success"
              this.snackbarText = "Le port a été ajouté avec succès."
              this.snackbar = true
              this.$emit('reloadData', true)
              this.closeDialog()
            }
            
          }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
          })
      },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/database/port/add.component.vue